import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';

import { hasAssemblyPermission, hasTrussDesignPermission } from '@paragon/login-tools';
import { WalkthroughBlurbAnchor } from '@paragon/tour-guide';

import { categorizeSelectableItemType } from '../../../../../library/selection/types';
import { useAppMonitor } from '../../../../../monitor';
import { DeletionActionFactory, getDeletionProps } from '../../../../../store/actions/deletionActions';
import { getSelectedItemEntries } from '../../../../../store/selectors/getSelectedItemSelector';
import { inViewOnlyMode } from '../../../../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { ButtonBarButton } from './common';

export function DeleteSelectedButton() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const isViewOnly = useAppSelector(inViewOnlyMode);
  const hasDesignPermission = useAppSelector(hasTrussDesignPermission);

  const selectedEntries = useAppSelector(getSelectedItemEntries);
  const deletionProps = useAppSelector(getDeletionProps);

  const isAssemblyUser = useAppSelector(hasAssemblyPermission);
  const inStation = useAppSelector((state) => state.application.openContext?.type === 'station');

  const deletionActionFactory = new DeletionActionFactory(selectedEntries, deletionProps);

  // assembly users need to be able to remove components from a station
  const assemblySpecialCaseActive =
    isAssemblyUser && inStation && selectedEntries.every(({ type }) => type === 'componentDesign');

  if (isViewOnly || (!hasDesignPermission && !assemblySpecialCaseActive)) return null;

  return (
    <WalkthroughBlurbAnchor id="delete-selected-button" blurbPlacement="bottom">
      <ButtonBarButton
        title="Delete Selected Item(s)"
        icon={DeleteIcon}
        disabled={
          !deletionActionFactory.isDeletionFeasible() ||
          !selectedEntries.every((entry) => {
            const category = categorizeSelectableItemType(entry.type);
            return category === 'layout' || category === 'design';
          })
        }
        onClick={() => {
          dispatch(deletionActionFactory.getDeletionAction());
          monitor.recordInteraction('Delete Selected button clicked');
        }}
      />
    </WalkthroughBlurbAnchor>
  );
}
